import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmGlobalOpsReportsRoute: InvariantJiraRoute = {
	name: 'products-jsm-global-ops-reports',
	path: '/jira/settings/products/ops/reports/:dashboardId',
	exact: true,
};
